import React, { useState } from 'react';
import Flow from 'components/common/flow/flow';
import Heading from 'components/common/heading/heading';
import { Table } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import SiteContext from 'components/shared/siteContext/siteContext';
import BackofficeReportsHelper from 'components/navigation/backofficeReports/backofficeReportsHelper';
import useAsyncEffect from 'use-async-effect';
import './employeeList.css';
import StoreStats from './storeStats';
import employeeService from 'services/employeeService';

export default function EmployeeList(props) {
  //const [filters, setFilters] = useState();
  const [filterString, setFilterString] = useState('');
  const [hierarchyId, setHierarchyId] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [employees, setEmployees] = useState([]);

  useAsyncEffect(async () => {
    const hierarchyId = await BackofficeReportsHelper.getSiteContextHierarchy();
    setHierarchyId(hierarchyId);
    const storeEmployees = await employeeService.listEmployeesByHierarchyId(hierarchyId);
    setEmployees(storeEmployees);
    setIsLoaded(true);
  }, [hierarchyId]);

  const handleSelectSite = (id) => {
    BackofficeReportsHelper.setSiteContextHierarchy(id);
    setHierarchyId(id);
  };

  const renderEmployees = () => {
    return employees.map((employee, index) => (
      <tr key={index} onClick={() => props.history.push(`/EmployeeList/${employee.employeeId}`)}>
        <td>{`${employee.firstName} ${employee.lastName}`}</td>
        <td>{employee.employeeNumber}</td>
        <td>{employee.type}</td>
      </tr>
    ));
  };

  return (
    <Flow className='employee-list'>
      <Flow.Header>
        <Heading>
          <SiteContext.Button loaded={isLoaded} hierarchyId={hierarchyId} onSelectSite={handleSelectSite} />
          <div className='flex-grow-1'>
            <Inputs.Text.Throttled
              placeholder='Search'
              value={filterString}
              onValueChange={(value) => setFilterString(value.toLowerCase())}
              //style={filterString.length ? (filterString.length >= 3 ? styles.validTextInput : styles.invalidTextInput) : styles.textInput}
              debounceDelay={400}
              required={true}
            />
          </div>
          <div>
            <Inputs.Button variant='default' iconClass='icons8-filter' label='Filter' />
            <Inputs.Button variant='default' href='/EmployeeList/Add' iconClass='icons8-plus-math' label='Create Employee' />
          </div>
          <StoreStats />
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th width='1'>
                <i className='icons8-numbered-list' />
              </th>
              <th width='1'>
                <i className='icons8-person' />
              </th>
            </tr>
          </thead>
          <tbody>{renderEmployees()}</tbody>
        </Table>
      </Flow.Body>
    </Flow>
  );
}
